import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }

  public displayEnvironmentBar(): boolean {
    const ALLOWED_ORIGINS: string[] = [
      'http://localhost:4200',
      'https://leads-finder-genie-dev.web.app',
      'https://leads-finder-genie-qa.web.app',
      'https://leads-finder-genie-staging.web.app',
    ];
    const URL: string = window.location.origin;
    return ALLOWED_ORIGINS.filter((origin: string) => origin === URL).length > 0 ? true : false;
  }
}
